module.exports = __webpack_public_path__ + "img/what-is-the-roi-on-events.290d4445.jpg";